/**
 * @Description 选址地图青春版本
 */

import { get, post } from '../request';

/**
 * 竞品品牌开店趋势
 * https://yapi.lanhanba.com/project/349/interface/api/86162
 */
export function brandMonthTendency(params: any) {
  return get('/youth/map/queryMonthTendency', { ...params });
}
/**
 * 地图品牌数量top6
 * https://yapi.lanhanba.com/project/349/interface/api/88764
 */
export function brandShopCountList(params: any) {
  return post('/youth/map/getBrandShopCountList', { ...params });
}

/**
 * 本品牌开店趋势
 * https://yapi.lanhanba.com/project/349/interface/api/86666
 */
export function queryOpeningTendency(params: any) {
  return get('/youth/map/queryOpeningTendency', { ...params });
}
/**
 * 商圈-概览基础信息
 * https://yapi.lanhanba.com/project/546/interface/api/88398
 */
export function getOverviewBase(params: any) {
  return post('/youth/map/modelCluster/overview/base', params);
}

/**
 * 商圈-评分数据
 * https://yapi.lanhanba.com/project/546/interface/api/88776
 */
export function getClusterScores(params: any) {
  return post('/youth/map/modelCluster/scores', params);
}
/**
 * 分享-商圈-评分数据
 * https://yapi.lanhanba.com/project/546/interface/api/88776
 */
export function getShareClusterScores(params: any) {
  return post('/youth/map/modelCluster/share/scores', params);
}


/**
 * 商圈-商圈内包含信息
 * https://yapi.lanhanba.com/project/546/interface/api/88404
 */
export function getClusterBrands(params: any) {
  return post('/youth/map/modelCluster/containInfo', params);
}


/**
 * 查询打卡任务
 * https://yapi.lanhanba.com/project/546/interface/api/88220
 */
export function postCheckInQueryTaskModelList(params: any) {
  return post('/standard/checkIn/queryTaskModelList', { ...params });
}

/**
 * 创建打卡任务
 * https://yapi.lanhanba.com/project/546/interface/api/88218
 */
export function postCheckInCreateTask(params: any) {
  return post('/standard/checkIn/createTask', { ...params });
}

/**
 * 商圈-人口数据
 * https://yapi.lanhanba.com/project/546/interface/api/88430
 */
export function getPopulationInfo(params: any) {
  return post('/youth/map/modelCluster/population', params);
}
/**
 * 分享-商圈-人口数据
 * https://yapi.lanhanba.com/project/546/interface/api/88578
 */
export function getSharePopulationInfo(params: any) {
  return post('/youth/map/modelCluster/share/population', params);
}
/**
 * 商圈-经营门店tab
 * https://yapi.lanhanba.com/project/546/interface/api/88564
 */
export function getStoreTabs(params: any) {
  return post('/youth/map/modelCluster/surround/levelCount', params);
}
/**
 * 分享-商圈-经营门店tab
 * https://yapi.lanhanba.com/project/546/interface/api/88564
 */
export function getShareStoreTabs(params: any) {
  return post('/youth/map/modelCluster/share/surround/levelCount', params);
}
/**
 * 商圈-经营门店列表-poi
 * https://yapi.lanhanba.com/project/546/interface/api/88566
 */
export function getStorePoiList(params: any, config?:any) {
  return post('/youth/map/modelCluster/surround/poi/levelPage', params, config);
}
/**
 * 分享-商圈-经营门店列表-poi
 * https://yapi.lanhanba.com/project/546/interface/api/88582
 */
export function getShareStorePoiList(params: any, config?:any) {
  return post('/youth/map/modelCluster/share/surround/poi/levelPage', params, config);
}
/**
 * 商圈-经营门店列表-知名品牌
 * https://yapi.lanhanba.com/project/546/interface/api/88568
 */
export function getStoreFamousList(params: any, config?:any) {
  return post('/youth/map/modelCluster/surround/famousBrand/levelPage', params, config);
}
/**
 * 分享-商圈-经营门店列表-知名品牌
 * https://yapi.lanhanba.com/project/546/interface/api/88584
 */
export function getShareStoreFamousList(params: any, config?:any) {
  return post('/youth/map/modelCluster/share/surround/famousBrand/levelPage', params, config);
}
/**
 * 商圈-经营门店列表-竞品门店
 * https://yapi.lanhanba.com/project/546/interface/api/88570
 */
export function getStoreCompetitorsList(params: any, config?:any) {
  return post('/youth/map/modelCluster/surround/competitors/levelPage', params, config);
}
/**
 * 分享-商圈-经营门店列表-竞品门店
 * https://yapi.lanhanba.com/project/546/interface/api/88586
 */
export function getShareStoreCompetitorsList(params: any, config?:any) {
  return post('/youth/map/modelCluster/share/surround/competitors/levelPage', params, config);
}

/**
 * 商圈-详情
 * https://yapi.lanhanba.com/project/623/interface/api/88638
 */
export function getYouthModelClusterDetail(params: any, config?:any) {
  return get('/youth/map/modelCluster/detail', params, config);
}


/**
 * by - receiveSession
 */
export function getYouthScreeningList(params: any) {
  return post('/youth/map/screeningList', params);
}
/**
 * 获取品牌商圈列表
 * https://yapi.lanhanba.com/project/546/interface/api/88998
 */
export function getBrandPolygonList(params:any) {
  return post(`/customBrandCluster/page`, params);
}

/**
 * 选址地图青春版-区域保护列表(开启地图要素显示-区域保护)
 * https://yapi.lanhanba.com/project/546/interface/api/89014
 */
export function regionalProtectionList(params: any) {
  return post('/youth/map/layer/regionalProtection', params);
}
